var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { tokenService } from "sbtech-sports-data-api-client";
import { internalMessageBus, InternalMessageBusChannels } from "sb-internal-msg-bus";
/**
 * Global configuration for SportDataApi/BFF
 */
export class GlobalConfigs {
    constructor(config) {
        this.authorization = { token: "" };
        this.apiConfigs = config.apiConfigs;
        this.isDebug = config.isDebug;
        this.getToken = config.getToken;
    }
    setAuthorization(authorization) {
        this.authorization = authorization;
        tokenService.apiAccessToken = authorization.token;
    }
    getAuthorization() {
        return this.authorization;
    }
}
export var GlobalConfig = new GlobalConfigs({
    apiConfigs: {
        sportDataApiUrl: "",
        bffApiUrl: "",
        locale: "",
        betsApiUrl: ""
    },
    getToken: () => { throw ("Not Initialized"); },
    isDebug: false
});
/**
 * init function initialize GlobalConfig object
 * @param config {GlobalConfig} config object to override the default values
 */
export const init = (config) => __awaiter(void 0, void 0, void 0, function* () {
    !Object.isFrozen(GlobalConfig.apiConfigs)
        && (GlobalConfig.apiConfigs = Object.assign(Object.assign({}, GlobalConfig.apiConfigs), config.apiConfigs))
        && Object.freeze(GlobalConfig.apiConfigs);
    GlobalConfig.getToken = config.getToken;
    GlobalConfig.isDebug = config.isDebug;
    internalMessageBus.on(InternalMessageBusChannels.legacy.anonymousJWTChange.renewJWTToken, (msg) => {
        msg.data[0] && msg.data[0].token && GlobalConfig.setAuthorization(msg.data[0]);
    });
    const token = yield GlobalConfig.getToken();
    GlobalConfig.setAuthorization({ token });
});
//# sourceMappingURL=init.js.map